import {
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_IN_REQUEST,
  GET_USER_FAILURE,
  GET_USER_SUCCESS,
  GET_USER_REQUEST,
  UPDATE_GUEST_FAILURE,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_REQUEST,
  LOGOUT,
} from '@store/guest/actions';

export const initialState = {
  guest: null,
  isGuestFetching: false,
  isLoginFetching: false,
  isUpdateFetching: false,
};

const reducers = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case SIGN_IN_REQUEST:
      return {
        ...state,
        isLoginFetching: true,
        guest: null,
      };
    case SIGN_IN_FAILURE:
      return {
        ...state,
        isLoginFetching: false,
        guest: null,
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        isLoginFetching: false,
        guest: payload,
      };
    case LOGOUT:
      return {
        ...state,
        guest: null,
      };
    case GET_USER_REQUEST:
      return {
        ...state,
        isGuestFetching: true,
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        guest: null,
        isGuestFetching: false,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        guest: payload,
        isGuestFetching: false,
      };
    case UPDATE_GUEST_REQUEST:
      return {
        ...state,
        isUpdateFetching: true,
      };
    case UPDATE_GUEST_FAILURE:
      return {
        ...state,
        isUpdateFetching: false,
      };
    case UPDATE_GUEST_SUCCESS:
      return {
        ...state,
        guest: payload,
        isUpdateFetching: false,
      };
    default: {
      return state;
    }
  }
};

export default reducers;
